import { style } from "@vanilla-extract/css";

export const footerStyle = style({
  padding: "var(--padding)",
  paddingTop: 0,
});
